import React from 'react';
import { Users } from 'lucide-react';
import { Coach } from '../../types/Coach';
// Use PlayerEvaluation type directly as it now includes team_recommendations as string[]
import { PlayerEvaluation } from '../../types/playerEvaluation';
import AssessmentSummary from './AssessmentSummary';

interface OtherEvaluationsListProps {
  playerEvaluations: PlayerEvaluation[]; // List of evaluations (already filtered excluding current coach)
  coaches: Coach[];
  // currentCoachId: string; // Removed - filtering happens in parent
  // currentEvaluationId: string; // Removed - filtering happens in parent
  ageGroupName: string;
}

const OtherEvaluationsList: React.FC<OtherEvaluationsListProps> = ({
  playerEvaluations, // Use the passed-in (pre-filtered) list
  coaches,
  ageGroupName
}) => {

  // No need to filter here anymore, assuming parent component pre-filters
  const otherEvaluations = playerEvaluations;

  if (otherEvaluations.length === 0) {
    // Return null or a message if desired, e.g.,
     return <p className="text-sm text-gray-500 border-t pt-4 text-center">No other evaluations submitted yet.</p>;
     // Or return null if you want nothing shown
     // return null;
  }

  return (
    <div className="border-t pt-6">
      <h3 className="text-lg font-medium text-gray-900 flex items-center mb-4">
        <Users className="h-5 w-5 mr-2 text-blue-600" />
        Other Evaluations ({otherEvaluations.length})
      </h3>
      <div className="space-y-4">
        {otherEvaluations.map(coachEvaluation => {
           const evaluationDate = coachEvaluation.updated_at || coachEvaluation.created_at;
           const displayDate = evaluationDate
             ? new Date(evaluationDate).toLocaleDateString(undefined, {
                 month: '2-digit',
                 day: '2-digit',
                 year: 'numeric'
               })
             : 'Unknown Date';

            // Team recommendations should be string[] as per PlayerEvaluation type
            const teamRecs = coachEvaluation.team_recommendations || [];

           return (
              <div key={coachEvaluation.id || coachEvaluation.coach_id} className="bg-gray-50 p-4 rounded-lg shadow-sm">
                <div className="flex items-center justify-between mb-2">
                  <span className="font-medium text-sm text-gray-700">
                    {coaches.find(c => c.id === coachEvaluation.coach_id)?.name || `Coach ID: ${coachEvaluation.coach_id?.substring(0, 6)}...`}
                  </span>
                </div>
                <AssessmentSummary
                  assessment={coachEvaluation} // Pass the full evaluation object
                  evaluationDate={displayDate}
                  ageGroupName={ageGroupName}
                />
                {/* Display team recommendations if they exist */}
                {teamRecs.length > 0 && (
                  <div className="mt-3">
                    <span className="text-sm font-medium text-gray-700 block mb-1">Team Recommendations:</span>
                    <div className="flex flex-wrap gap-1">
                      {teamRecs.map(level => (
                        <span key={level} className="px-2 py-1 text-xs font-medium bg-blue-100 text-blue-800 rounded">
                          {level}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
              </div>
           );
        })}
      </div>
    </div>
  );
};

export default OtherEvaluationsList;